var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8594 16.4883L13.6055 12.2344C13.5 12.1641 13.3945 12.0938 13.2891 12.0938H12.832C13.9219 10.8281 14.625 9.14062 14.625 7.3125C14.625 3.30469 11.3203 0 7.3125 0C3.26953 0 0 3.30469 0 7.3125C0 11.3555 3.26953 14.625 7.3125 14.625C9.14062 14.625 10.793 13.957 12.0938 12.8672V13.3242C12.0938 13.4297 12.1289 13.5352 12.1992 13.6406L16.4531 17.8945C16.6289 18.0703 16.9102 18.0703 17.0508 17.8945L17.8594 17.0859C18.0352 16.9453 18.0352 16.6641 17.8594 16.4883ZM7.3125 12.9375C4.18359 12.9375 1.6875 10.4414 1.6875 7.3125C1.6875 4.21875 4.18359 1.6875 7.3125 1.6875C10.4062 1.6875 12.9375 4.21875 12.9375 7.3125C12.9375 10.4414 10.4062 12.9375 7.3125 12.9375Z",
    fill: "#406BBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/Search_Icon.1fcac9d5db782f76dee87e19b51b5579.svg";
export { ForwardRef as ReactComponent };